import { Box, Typography } from '@mui/material';
import { HorizontalRule } from '@mui/icons-material';

interface CustomLabelProps {
    name: string;
    description?: string;
}

export const CustomLabel = ({ name, description }: CustomLabelProps) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '16px', width: 'auto' }}>{name}</Typography>
        {description && (
            <>
                <HorizontalRule sx={(theme) => ({ fontSize: '14px', mx: '4px', color: theme.palette.primary[400] })} />
                <Typography
                    sx={(theme) => ({
                        color: theme.palette.primary[400],
                        fontSize: '14px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '35%'
                    })}
                >
                    {description}
                </Typography>
            </>
        )}
        {/* {isPinned && (
            <PushPinOutlined sx={(theme) => ({ fontSize: '1rem', color: theme.palette.primary[400], transform: 'rotate(35deg)' })} />
        )} */}
    </Box>
);
